export interface PortfolioAllocations {
  [indexId: string]: any;
}

const portfolioAllocationsStore: PortfolioAllocations = {};

export { portfolioAllocationsStore };
